export * from '../modules/PropTypes'


//////////////////
// WEBPACK FOOTER
// ../node_modules/javascript-time-ago/prop-types/index.js
// module id = 3265
// module chunks = 0